module.exports = __webpack_public_path__ + "img/service-nongmaojianguan1.6dc816b7.svg";